import { render, staticRenderFns } from "./TagsManager.vue?vue&type=template&id=ff676ce2&"
import script from "./TagsManager.vue?vue&type=script&lang=js&"
export * from "./TagsManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports